import { FiAlertTriangle } from 'react-icons/fi';
import { MdMoneyOff, MdOutlineInfo, MdOutlinePayments } from 'react-icons/md';

import { ResumeCard, Tooltip } from 'components';
import { integerToCurrency } from 'helpers';
import { PixTransactionsResume } from 'types';

export function TransactionsResume({
  resumeData,
  isLoading,
}: {
  resumeData: PixTransactionsResume | undefined;
  isLoading: boolean;
}) {
  const {
    walletBalance = { value: 0 },
    failedTransferTotal = { value: 0 },
    failedTransferCount = 0,
    balanceUpdatedAt,
  } = resumeData ?? {};

  const lastUpdateText = balanceUpdatedAt
    ? new Date(balanceUpdatedAt).toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      })
    : undefined;

  return (
    <>
      <ResumeCard
        icon={<MdOutlinePayments size={32} />}
        label={
          <>
            Saldo da wallet{' '}
            <Tooltip
              message={
                'Saldo da carteira matriz da empresa, ele será repassado as lojas'
              }
            >
              <MdOutlineInfo size={16} />
            </Tooltip>
          </>
        }
        subtitle={lastUpdateText && `Última atualização ${lastUpdateText}`}
        value={integerToCurrency(walletBalance.value, {
          removeCurrencySymbol: true,
        })}
        valueColor={
          walletBalance.value > 0 ? 'text-success-300' : 'text-danger-300'
        }
        isPrice
        isLoading={isLoading}
      />
      <ResumeCard
        icon={<MdMoneyOff size={32} />}
        label={
          <>
            Saldo de transferências com falha{' '}
            <Tooltip message={'Saldo somado de todas transferências com falha'}>
              <MdOutlineInfo size={16} />
            </Tooltip>
          </>
        }
        value={integerToCurrency(failedTransferTotal.value, {
          removeCurrencySymbol: true,
        })}
        valueColor="text-warning-500"
        isPrice
        isLoading={isLoading}
      />
      <ResumeCard
        icon={<FiAlertTriangle size={32} />}
        label={
          <>
            Total de transações com falha{' '}
            <Tooltip
              message={
                'Transferências com falha podem ocorrer por problema no destinatário ou problemas técnicos.'
              }
            >
              <MdOutlineInfo size={16} />
            </Tooltip>
          </>
        }
        value={failedTransferCount}
        valueColor="text-warning-500"
        isLoading={isLoading}
      />
    </>
  );
}
